// PrecoDashboard.tsx
import React, { useState } from 'react';
import '../../styles/dashboardPagesStyle/Charts.css';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  LabelList
} from 'recharts';
import { Info } from 'lucide-react';

export interface GraficoBarDataItem {
  categoria: string; // pode ser cidade, mês, etc
  valor: number;
}

interface PrecoDashboardProps {
  titulo: string;
  dados: GraficoBarDataItem[];
  dataKey: keyof GraficoBarDataItem; // chave do valor a ser exibido
  infoText?: string;
  corBarra?: string;
}

export default function GraficoBar({ titulo, dados, dataKey, infoText, corBarra = '#29306A' }: PrecoDashboardProps) {
  const [popup, setPopup] = useState<{ visible: boolean; text: string }>({
    visible: false,
    text: '',
  });

  const handleInfoClick = () => {
    if (infoText) {
      setPopup({ visible: true, text: infoText });
    }
  };

  const fecharPopup = () => setPopup({ visible: false, text: '' });

  return (
    <div className="card-grafico-preco info-card">
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <h3>{titulo}</h3>
        {infoText && <Info className="info-btn" size={20} onClick={handleInfoClick} />}
      </div>

      <ResponsiveContainer width="100%" height={200}>
        <BarChart data={dados} margin={{ right: 3, left: -10, top: 10 }}>
          <XAxis dataKey="categoria" />

          {/* YAxis com labels menores e valores em milhares */}
          <YAxis
            tickFormatter={(valor) => `${(valor / 1000).toFixed(1)}k`} // ex: 128.2k
            tick={{ fontSize: 12 }}
          />

          {/* Tooltip também formatado em milhares */}
          <Tooltip formatter={(value: number) => `${(value / 1000).toFixed(1)}k`} />

          <Bar dataKey={dataKey} fill={corBarra}>
            <LabelList
              dataKey={dataKey}
              position="top"
              fill={corBarra}
              fontSize={8.5}
              formatter={(valor: any) => {
                if (typeof valor === 'number') return `${(valor / 1000).toFixed(1)}k`;
                return valor;
              }}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>

      {popup.visible && (
        <div className="info-popup-overlay" onClick={fecharPopup}>
          <div className="info-popup" onClick={e => e.stopPropagation()}>
            <h4>Informações</h4>
            <p>{popup.text}</p>
            <button onClick={fecharPopup}>Fechar</button>
          </div>
        </div>
      )}
    </div>
  );
}
